import firebase from 'firebase'
import 'firebase/auth'
import types from 'types'

export const signInWithGoogle = () => async dispatch => {
  dispatch({
    type: types.SETTING_USER,
  });

  const provider = new firebase.auth.GoogleAuthProvider();
  try {
    const user = await firebase.auth().signInWithPopup(provider);
  } catch(error) {
    dispatch({
      type: types.ERROR_SETTING_USER,
      payload: error,
    })
  }
}

export const setUserData = (user) => dispatch => {
  dispatch({
    type: types.USER_SET,
    payload: user,
  })
}
